import moment from 'moment';

export const getDateRange = (type) => {
    let date = {
        query: {
            startDate: Date.now(),
            endDate: Date.now()
        },
        text: moment().format('YYYY-MM-DD'),
        type:"Today"
    }
    switch (type) {
        case "TODAY":
            date.query.startDate = moment().startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().format('YYYY-MM-DD');
            date.text = `Today - ${moment().startOf('day').format('Do MMM')}`
            date.type = 'Today';
            break;
        case "YESTERDAY":
            date.query.startDate = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DD');
            date.text = `Yesterday - ${moment().subtract(1, 'day').startOf('day').format('Do MMM')}`;
            date.type = 'Yesterday';
            break;
        case "THISWEEK":
            date.query.startDate = moment().startOf('week').format('YYYY-MM-DD');
            date.query.endDate = moment().format('YYYY-MM-DD');
            date.text = `${moment().startOf('week').format('Do MMM')} - ${moment().format('Do MMM')}`;
            date.type = 'This Week';
            break;
        case "LASTWEEK":
            date.query.startDate = moment().subtract(moment().day() + 1, 'days').startOf('week').format('YYYY-MM-DD');
            date.query.endDate = moment().subtract(moment().day() + 1, 'days').endOf('week').format('YYYY-MM-DD');
            date.text = `${moment().subtract(moment().day() + 1, 'days').startOf('week').format('Do MMM')} - ${moment().subtract(moment().day() + 1, 'days').endOf('week').format('Do MMM')}`;
            date.type = 'Last Week';
            break;
        case "LAST30DAYS":
            date.query.startDate = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(30, 'days').startOf('day').format('Do MMM')} - ${moment().endOf('day').format('Do MMM')}`;
            date.type = 'Last 30 Days';
            break;
        case "THISMONTH":
            date.query.startDate = moment().startOf('month').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().startOf('month').format('Do MMM')} - ${moment().endOf('day').format('Do MMM')}`;
            date.type = 'This Month';
            break;
        case "LASTMONTH":
            date.query.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            date.query.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            date.text = `${moment().subtract(1, 'months').startOf('month').format('Do MMM')} - ${moment().subtract(1, 'months').endOf('month').format('Do MMM')}`;
            date.type = 'Last Month';
            break;
        case "3MONTHS":
            date.query.startDate = moment().subtract(3, 'months').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(3, 'months').startOf('day').format('Do MMM, YY')} - ${moment().endOf('day').format('Do MMM, YY')}`;
            date.type = '3 Months';
            break;
        case "6MONTHS":
            date.query.startDate = moment().subtract(6, 'months').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(6, 'months').startOf('day').format('Do MMM, YY')} - ${moment().endOf('day').format('Do MMM, YY')}`;
            date.type = '6 Months';
            break;
        case "1YEAR":
            date.query.startDate = moment().subtract(1, 'years').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(1, 'years').startOf('day').format('Do MMM, YY')} - ${moment().endOf('day').format('Do MMM, YY')}`;
            date.type = '1 Year';
            break;
        case "2YEAR":
            date.query.startDate = moment().subtract(2, 'years').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(2, 'years').startOf('day').format('Do MMM, YY')} - ${moment().endOf('day').format('Do MMM, YY')}`;
            date.type = '2 Years';
            break;
        case "5YEAR":
            date.query.startDate = moment().subtract(5, 'years').startOf('day').format('YYYY-MM-DD');
            date.query.endDate = moment().endOf('day').format('YYYY-MM-DD');
            date.text = `${moment().subtract(5, 'years').startOf('day').format('Do MMM, YY')} - ${moment().endOf('day').format('Do MMM, YY')}`;
            date.type = '5 Years';
            break;
    }
    return date;
}